import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services';

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss']
})
export class TestComponent implements OnInit {

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
  }

  verifyToken() {
    this.authService.ValidateAndRefreshToken();
  }

  refreshToken() {
    this.authService.RefreshToken().subscribe({
      next: (res) => {
        console.log("Token refreshed", res);
      },
      error: (err) => {
        console.error("Error refreshing token", err);
      }
    });
  }
}
